import React from 'react';
import { Toaster, type ToasterProps } from 'sonner';

export function AppToaster(props: Readonly<ToasterProps>) {
  return (
    <Toaster
      position="top-right"
      closeButton
      richColors
      offset={16}
      toastOptions={{
        className:
          'rounded-md border border-border/70 bg-background text-foreground shadow-surface',
      }}
      {...props}
    />
  );
}
